"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Productshowcase() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const values = [{
    numeral: "01",
    title: "全球醫療採購",
    description: "我們連結世界級醫療製造商與當地醫療提供者，確保獲得全球最創新的技術。"
  }, {
    numeral: "02",
    title: "臨床產品評估",
    description: "我們的團隊嚴格評估每一種設備的臨床療效與安全性，讓醫療專業人員能有信心地採用新解決方案。"
  }, {
    numeral: "03",
    title: "國際配銷",
    description: "我們管理複雜的物流與供應鏈，確保優質醫療設備高效地完好送達目的地。"
  }, {
    numeral: "04",
    title: "戰略性合作夥伴關係",
    description: "除了配銷，我們是長期合作夥伴，提供法規支援和市場見解，幫助經銷商與製造商在競爭激烈的市場中蓬勃發展。"
  }];
  return <section data-section-id="3603" id="productshowcase" className="bg-background text-foreground py-[200px] px-6 md:px-10 lg:px-16 relative overflow-hidden">
      {}
      <div ref={headerRef} className={`max-w-7xl mx-auto mb-20 md:mb-28 transition-all duration-1000 ease-out ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="grid grid-cols-12 gap-4 items-end">
          <div className="col-span-12 md:col-span-3">
            <span className="font-default text-xs tracking-widest uppercase" style={{
            color: "var(--chart-3)"
          }}>
              03 / 核心價值
            </span>
          </div>
          <div className="col-span-12 md:col-span-9">
            <h2 className="font-default font-bold leading-[0.95] tracking-tight" style={{
            fontSize: "clamp(3rem, 8vw, 8rem)"
          }}>
              <span className="block text-foreground">我們的戰略</span>
              <span className="block font-default italic font-light" style={{
              color: "var(--chart-3)"
            }}>
                承諾
              </span>
            </h2>
          </div>
        </div>
        <div className="mt-12 h-px w-full bg-border" />
      </div>

      {}
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
        {values.map((value, i) => {
        const isFourth = i === 3;
        return <ValueCard key={i} data-index={i} numeral={value.numeral} title={value.title} description={value.description} spanTwo={isFourth} />;
      })}
      </div>
    </section>;
}
function ValueCard({
  numeral,
  title,
  description,
  spanTwo,
  ...rest
}: {
  numeral: string;
  title: string;
  description: string;
  spanTwo?: boolean;
  [key: string]: unknown;
}) {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>();
  return <div ref={ref} {...rest} className={`group relative p-8 md:p-10 lg:p-12 border border-border backdrop-blur-sm shadow-lg transition-all duration-500 ease-out hover:-translate-y-1.5 hover:shadow-xl rounded-lg ${spanTwo ? "lg:col-span-2" : ""} ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`} style={{
    backgroundColor: "var(--card)"
  }}>
      {}
      <div className="font-default font-light leading-none mb-6 transition-all duration-500 group-hover:[text-shadow:0_0_30px_var(--chart-3)]" style={{
      fontSize: "4rem",
      color: "var(--chart-3)"
    }}>
        {numeral}
      </div>

      {}
      <div className="h-px w-full bg-border mb-6" />

      {}
      <h3 className="font-default font-bold text-foreground mb-4 leading-tight" style={{
      fontSize: "1.75rem"
    }}>
        {title}
      </h3>

      {}
      <p className="font-default text-base leading-relaxed" style={{
      color: "var(--muted-foreground)"
    }}>
        {description}
      </p>

      {}
      <div className="absolute top-0 right-0 w-px h-12 transition-all duration-500 group-hover:h-20" style={{
      backgroundColor: "var(--chart-3)"
    }} />
    </div>;
}